export const GET_POS_INTEGRATIONS = 'GET_POS_INTEGRATIONS';
export const SET_POS_INTEGRATIONS = 'SET_POS_INTEGRATIONS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_POS_INTEGRATION = 'SET_POS_INTEGRATION';
export const ADD_POS_INTEGRATION = 'ADD_POS_INTEGRATION';
export const EMPTY_POS_INTEGRATION = 'EMPTY_POS_INTEGRATION';
export const DELETE_POS_INTEGRATION = 'DELETE_POS_INTEGRATION';
export const EDIT_POS_INTEGRATION = 'EDIT_POS_INTEGRATION';
export const UPDATE_POS_INTEGRATION = 'UPDATE_POS_INTEGRATION';
export const SET_POS_INTEGRATION_FILTER = 'SET_POS_INTEGRATION_FILTER';
export const GET_POS_INTEGRATIONS_LIST = 'GET_POS_INTEGRATIONS_LIST';
export const SET_POS_INTEGRATIONS_LIST = 'SET_POS_INTEGRATIONS_LIST';